"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.absorbedEmailKeptAsSecondary = exports.isEmailKeptAfterMerge = exports.computeMergedContact = exports.computeMergedContactEmails = exports.splitGuestName = exports.GUEST_NAME_SUFFIXES = void 0;
exports.GUEST_NAME_SUFFIXES = [
    "Jr",
    "Jr.",
    "Sr",
    "Sr.",
    "II",
    "III",
    "IV",
    "V",
    "MD",
    "M.D.",
    "DO",
    "DDS",
    "DMD",
    "DVM",
    "OD",
    "PA",
    "NP",
    "RN",
    "RD",
    "LCSW",
    "MSW",
    "PhD",
    "PHD",
    "Ph.D.",
    "EdD",
    "Ed.D.",
    "JD",
    "Esq",
    "Esq.",
    "CPA",
    "MBA",
    "CFRE",
];
const NAME_SUFFIXES = Object.fromEntries(exports.GUEST_NAME_SUFFIXES.map((suffix) => [suffix, true]));
const splitGuestName = (fullName) => {
    const normalized = fullName.trim().replace(/\s+/g, " ");
    const comma = /,\s*[^\s,]+$/.exec(normalized)?.[0] ?? "";
    const bare = comma === "" ? (/\s([^\s,]+)$/.exec(normalized)?.[1] ?? "") : "";
    const trailing = comma !== "" ? comma : NAME_SUFFIXES[bare] ? ` ${bare}` : "";
    const stripped = normalized.slice(0, normalized.length - trailing.length).trimEnd();
    const carriesSuffix = stripped.includes(" ");
    const base = carriesSuffix ? stripped : normalized;
    const suffix = carriesSuffix ? trailing : "";
    const cut = base.lastIndexOf(" ");
    if (cut === -1) {
        return { firstName: base, lastName: "" };
    }
    return { firstName: base.slice(0, cut), lastName: base.slice(cut + 1) + suffix };
};
exports.splitGuestName = splitGuestName;
const normalizeEmail = (value) => {
    const trimmed = value?.trim();
    return trimmed ? trimmed : null;
};
// Survivor's primary is never reassigned (may be account-linked); secondary can't equal primary (DB trigger). Callers lowercase before storing.
const computeMergedContactEmails = (survivor, absorbed) => {
    const survivorPrimary = normalizeEmail(survivor.email);
    const survivorSecondary = normalizeEmail(survivor.secondaryEmail);
    const absorbedPrimary = normalizeEmail(absorbed.email);
    const absorbedSecondary = normalizeEmail(absorbed.secondaryEmail);
    const email = survivorPrimary ?? absorbedPrimary;
    const secondaryEmail = [survivorPrimary ? absorbedPrimary : null, survivorSecondary, absorbedSecondary].find((candidate) => candidate !== null && candidate.toLowerCase() !== email?.toLowerCase()) ?? null;
    return { email, secondaryEmail };
};
exports.computeMergedContactEmails = computeMergedContactEmails;
// Mirrors the server merge backfill so the preview matches what gets stored.
const keepOrFill = (kept, absorbed) => {
    const trimmedKept = kept?.trim();
    if (trimmedKept) {
        return trimmedKept;
    }
    return absorbed?.trim() || null;
};
const computeMergedContact = (survivor, absorbed) => {
    const { email, secondaryEmail } = (0, exports.computeMergedContactEmails)(survivor, absorbed);
    return {
        firstName: keepOrFill(survivor.firstName, absorbed.firstName),
        lastName: keepOrFill(survivor.lastName, absorbed.lastName),
        phoneNumber: keepOrFill(survivor.phoneNumber, absorbed.phoneNumber),
        corporationName: keepOrFill(survivor.corporationName, absorbed.corporationName),
        address: keepOrFill(survivor.address, absorbed.address),
        city: keepOrFill(survivor.city, absorbed.city),
        postalCode: keepOrFill(survivor.postalCode, absorbed.postalCode),
        email,
        secondaryEmail,
    };
};
exports.computeMergedContact = computeMergedContact;
const isEmailKeptAfterMerge = (survivor, absorbed, email) => {
    const candidate = normalizeEmail(email)?.toLowerCase();
    if (!candidate) {
        return false;
    }
    const { email: mergedPrimary, secondaryEmail: mergedSecondary } = (0, exports.computeMergedContactEmails)(survivor, absorbed);
    return mergedPrimary?.toLowerCase() === candidate || mergedSecondary?.toLowerCase() === candidate;
};
exports.isEmailKeptAfterMerge = isEmailKeptAfterMerge;
const absorbedEmailKeptAsSecondary = (survivor, absorbed) => {
    const absorbedPrimary = normalizeEmail(absorbed.email);
    if (!absorbedPrimary) {
        return false;
    }
    const { secondaryEmail } = (0, exports.computeMergedContactEmails)(survivor, absorbed);
    return secondaryEmail?.toLowerCase() === absorbedPrimary.toLowerCase();
};
exports.absorbedEmailKeptAsSecondary = absorbedEmailKeptAsSecondary;
